import {Component, ViewChild} from '@angular/core';
import {CsvPropertiesConfirmResponse, CsvPropertiesMapRequest, FileUploadComponent, ProjectApiService} from '@cas-hub/acabim-common-client';
import {MessageService} from 'primeng/api';
import {SpaceCsvPropertiesConfirmResponse, SpaceCsvUpdateService} from '../../../_services/space-csv-update.service';

const enum CsvProcessingState {
    pending = 0, // Pending file upload
    waiting = 1, // Waiting for user to confirm
    processing = 2 // Processing the confirmation by the API
}

@Component({
    selector: 'acabim-admin-space-management',
    templateUrl: './space-management.component.html',
    styleUrls: ['./space-management.component.scss'],
    providers: [MessageService]
})
export class SpaceManagementComponent {

    @ViewChild('csvUploader', {static: false}) public csvUploader?: FileUploadComponent;

    public csvProcessingState = CsvProcessingState.pending;

    public set csvMapRequest(req: CsvPropertiesMapRequest | undefined) {
        this._csvMapRequest = req;
        if (req) {
            this.csvProcessingState = CsvProcessingState.waiting;
        }
    }

    public get csvMapRequest(): CsvPropertiesMapRequest | undefined {
        return this._csvMapRequest;
    }

    private _csvMapRequest?: CsvPropertiesMapRequest;

    constructor(public readonly projectApiService: ProjectApiService,
                public readonly messageService: MessageService,
                private readonly spaceCsvUpdateService: SpaceCsvUpdateService) { }


    public startImportSession(): void {
        if (this.csvUploader && this.csvUploader.file) {
            this.csvUploader.startUpload(this.spaceCsvUpdateService.startUpdateSession(this.csvUploader.file, (result => {
                this.csvMapRequest = result;
            })));
        }
    }

    public confirmCsvMapRequest(result: CsvPropertiesConfirmResponse): void {
        const projectId = this.projectApiService.selectedProjectId;
        if (projectId) {
            const spaceResult: SpaceCsvPropertiesConfirmResponse = {
                ...result,
                projectId
            };

            this.csvProcessingState = CsvProcessingState.processing;
            this.spaceCsvUpdateService.confirmUpdateSession(spaceResult).subscribe(_ => {
                this.messageService.add({severity: 'success', summary: 'Space data updated successfully'});
                this.csvMapRequest = undefined;
                this.csvProcessingState = CsvProcessingState.pending;
            }, error => {
                this.messageService.add({severity: 'error', summary: 'Unable to update Space data'});
                this.csvProcessingState = CsvProcessingState.waiting;
            });
        }
    }
}
